import React, { useContext } from 'react';
import CompC from './CompC';
import { FirstName, LastName } from './Context';
const CompB = () => {

  const fname = useContext (FirstName);
  const lname = useContext (LastName);
  return (
  // <CompC />
  <h1>My name is {fname} {lname} - {fname} {lname}</h1>
  )
};

export default CompB;